//@flow
import { gql, graphql } from "react-apollo"

const QUERY_CURRENT_KIOSK_DATA = gql`
  query FetchCurrentKioskData {
    currentKiosk {
      id
      friendlyName
      shortName
      usesVirtualKeyboard
      readings {
        live {
          o3
          pm2_5
          pm10
          occurredAt
        }
        history {
          o3
          pm2_5
          pm10
          occurredAt
        }
      }
    }
    publicKiosks {
      friendlyName
      latitude
      longitude
      id
      primarySensor {
        latitude
        longitude
      }
      readings {
        live {
          o3
          pm2_5
          pm10
          occurredAt
        }
      }
    }
  }
`

const withCurrentKioskData = graphql(QUERY_CURRENT_KIOSK_DATA, {
  name: "data"
})

export default withCurrentKioskData



// WEBPACK FOOTER //
// ./src/Kiosk/queries/withCurrentKioskData.js